import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "unit",
    serviceName: "graphql",
    query: gql`
      query unit($ids: [String], $for_admin: Int) {
        unit(ids: $ids, for_admin: $for_admin) {
          total
          data {
            id
            lat
            lng
            title
            address
            site_url
            is_active
            tellphone
            postal_code
            check_messages
            register_date
            registered_number
            national_identifier
            status {
              id
              title
            }
            city {
              title
              state {
                title
              }
            }
            media {
              id
              full_url
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
